import { atom } from '@exodus/headless-ui';
import fromAssetAtom from './from-asset.js';
import fromWalletAccountAtom from './from-wallet-account.js';
const fromAssetRestoringAtom = atom((get, { selectors }) => {
    const fromAsset = get(fromAssetAtom);
    const restoringAssets = get(selectors.restoringAssets.data);
    return Boolean(restoringAssets[fromAsset.baseAsset.name]);
});
const fromAssetAddressAtom = atom(async (get, { exodus }) => {
    get(fromAssetRestoringAtom);
    const fromAsset = get(fromAssetAtom);
    const fromWalletAccount = get(fromWalletAccountAtom);
    try {
        return await exodus.addressProvider.getReceiveAddress({
            assetName: fromAsset.name,
            walletAccount: fromWalletAccount.toString(),
        });
    }
    catch {
        return null;
    }
});
const fromAssetReadyAtom = atom(async (get) => {
    const fromAssetAddress = await get(fromAssetAddressAtom);
    const fromWalletAccount = get(fromWalletAccountAtom);
    if (!fromWalletAccount.isHardware)
        return true;
    return !!fromAssetAddress;
});
export default fromAssetReadyAtom;
